export enum OpenAIModel {
  GPT4OMini = 'gpt-4o-mini',
  GPT4O = 'gpt-4o',
  O3Mini = 'o3-mini',
  O1 = 'o1',
}

export enum ClaudeModel {
  Sonnet = 'claude-3.7-sonnet',
  Opus = 'claude-3-opus',
}

export enum DeepSeekModel {
  R1 = 'deepseek.r1-v1',
}

export enum GeminiModel {
  Flash = 'gemini-2.0-flash',
  FlashLite = 'gemini-2.0-flash-lite',
  Flash25 = 'gemini-2.5-flash',
  Pro25 = 'gemini-2.5-pro',
}

export type AIModel = OpenAIModel | ClaudeModel | DeepSeekModel | GeminiModel;

/**
 * Get a display name for a model
 * @param model The model identifier
 * @returns A user-friendly display name
 */
export function getModelDisplayName(model: AIModel): string {
  switch (model) {
    case OpenAIModel.GPT4OMini:
      return 'GPT-4o Mini';
    case OpenAIModel.GPT4O:
      return 'GPT-4o';
    case OpenAIModel.O3Mini:
      return 'O3 Mini';
    case OpenAIModel.O1:
      return 'O1';
    case ClaudeModel.Sonnet:
      return 'Claude 3.7 Sonnet';
    case ClaudeModel.Opus:
      return 'Claude 3 Opus';
    case DeepSeekModel.R1:
      return 'DeepSeek R1';
    case GeminiModel.FlashLite:
      return 'Gemini 2.0 Flash Lite';
    case GeminiModel.Flash:
      return 'Gemini 2.0 Flash';
    case GeminiModel.Flash25:
      return 'Gemini 2.5 Flash';
    case GeminiModel.Pro25:
      return 'Gemini 2.5 Pro';
    default:
      return model;
  }
}
